import React from "react";
import styled from "@emotion/styled";

const Container = styled.div`
	max-width: 900px;
	margin: 40px auto;
	padding: 32px;
	background: #fff;
	border-radius: 8px;
	box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
	line-height: 1.7;
	color: #333;

	h1 {
		font-size: 28px;
		margin-bottom: 8px;
	}

	h2 {
		font-size: 20px;
		margin-top: 28px;
		margin-bottom: 8px;
	}

	p,
	ul {
		margin-bottom: 12px;
	}

	ul {
		padding-left: 24px;
	}

	.effective-date {
		color: #888;
		font-size: 14px;
		margin-bottom: 24px;
	}
`;

const TermsOfUse: React.FC = () => {
	return (
		<Container>
			<h1>Terms of Use</h1>
			<p className="effective-date">Effective Date: February 25, 2026</p>

			<h2>1. Acceptance of Terms</h2>
			<p>
				By accessing or using the Nosey Frontend application (the &ldquo;Platform&rdquo;),
				you agree to be bound by these Terms of Use. This Platform is the
				exclusive property of Marathon Ventures Media Sales and is intended
				solely for use by authorized employees of Marathon Ventures Media Sales
				and its affiliates (&ldquo;Authorized Users&rdquo;). If you do not agree with these
				terms, you must not access or use the Platform.
			</p>

			<h2>2. Authorized Use</h2>
			<p>
				Access to the Platform is restricted to Authorized Users who have been
				granted credentials through Marathon Ventures Media Sales&apos; internal
				authentication systems (Google SSO). You may only use the Platform for
				legitimate business purposes directly related to your role and
				responsibilities within the organization.
			</p>

			<h2>3. Confidentiality</h2>
			<p>
				All data, content, and information accessible through the Platform is
				confidential and proprietary to Marathon Ventures Media Sales. You agree
				to:
			</p>
			<ul>
				<li>
					Not disclose, share, or distribute any information obtained through
					the Platform to unauthorized individuals or third parties.
				</li>
				<li>
					Not copy, reproduce, or export data from the Platform except as
					required for authorized business purposes.
				</li>
				<li>
					Comply with all applicable company data handling and confidentiality
					policies.
				</li>
			</ul>

			<h2>4. Acceptable Use</h2>
			<p>When using the Platform, you agree not to:</p>
			<ul>
				<li>
					Use the Platform for any purpose other than authorized business
					activities.
				</li>
				<li>
					Attempt to gain unauthorized access to any part of the Platform,
					other accounts, or systems.
				</li>
				<li>
					Introduce malicious code, viruses, or any harmful software to the
					Platform.
				</li>
				<li>
					Modify, reverse engineer, or attempt to extract the source code of
					the Platform.
				</li>
				<li>
					Share your login credentials or allow others to access the Platform
					using your account.
				</li>
				<li>
					Use the Platform in any way that violates applicable laws or
					regulations.
				</li>
			</ul>

			<h2>5. Intellectual Property</h2>
			<p>
				The Platform, including all software, content, designs, logos, and
				documentation, is the intellectual property of Marathon Ventures Media
				Sales. No right, title, or interest in the Platform is transferred to
				you. All rights not expressly granted herein are reserved.
			</p>

			<h2>6. Disclaimer of Warranties</h2>
			<p>
				The Platform is provided on an &ldquo;as is&rdquo; and &ldquo;as available&rdquo; basis for
				internal business use. Marathon Ventures Media Sales makes no
				warranties, express or implied, regarding the Platform&apos;s availability,
				accuracy, reliability, or fitness for a particular purpose. While we
				strive to maintain the Platform&apos;s functionality, we do not guarantee
				uninterrupted or error-free operation.
			</p>

			<h2>7. Limitation of Liability</h2>
			<p>
				To the fullest extent permitted by law, Marathon Ventures Media Sales
				shall not be liable for any indirect, incidental, special, or
				consequential damages arising out of or in connection with your use of
				the Platform, including but not limited to loss of data, business
				interruption, or any other damages.
			</p>

			<h2>8. Termination</h2>
			<p>
				Marathon Ventures Media Sales reserves the right to suspend or terminate
				your access to the Platform at any time, with or without notice, for
				any reason, including but not limited to violation of these Terms of
				Use, termination of employment, or changes to business requirements.
				Upon termination, your right to access the Platform ceases immediately.
			</p>

			<h2>9. Changes to Terms</h2>
			<p>
				Marathon Ventures Media Sales reserves the right to modify these Terms
				of Use at any time. Updated terms will be posted on the Platform, and
				your continued use of the Platform after changes are posted constitutes
				acceptance of the revised terms.
			</p>

			<h2>10. Contact</h2>
			<p>
				If you have questions about these Terms of Use, please contact your
				manager or the IT department at Marathon Ventures Media Sales.
			</p>
		</Container>
	);
};

export default TermsOfUse;
